(function () {
  // 等主题主脚本跑完再打补丁
  function ready(fn){ if(document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  ready(function(){
    if (!window.T4SThemeSP || !T4SThemeSP.Product || !T4SThemeSP.Product.prototype) return;

    var $ = window.jQuery_T4NT || window.jQuery || window.Zepto;
    if (!$) return;

    // 记录原始 init，确保我们在每次创建 Variants 后都能挂上补丁
    var _origInitVariants = T4SThemeSP.Product.prototype._initVariants;

    T4SThemeSP.Product.prototype._initVariants = function () {
      var ret = _origInitVariants.apply(this, arguments);

      try {
        if (this.Variants) {
          this.Variants._updateSwatchSelector = patchedUpdateSwatchSelector;
        }
      } catch (e) {
        console && console.warn && console.warn('[swatch-patch] hook failed:', e);
      }

      return ret;
    };

    // 核心补丁：用 data-value 精确匹配，修复 NA/索引错位、删除线反转、选中项丢失
    function patchedUpdateSwatchSelector(curVar, oldVar, $form, hasSoldoutUnavailable) {
      var SEL_ITEM = '[data-swatch-item]';
      var CLS_UNAVAIL = 'is--unavailable';
      var CLS_SOLD_UNAVAIL = 'is--soldout ' + CLS_UNAVAIL;

      var $opt1 = this.$options1 || $();
      var $opt2 = this.$options2 || $();
      var $opt3 = this.$options3 || $();

      var size = this.getProductSize || this.productOptionSize || 0;
      var variants = this.variants || [];

      // 清理旧状态
      $form.find('.is--selected').removeClass('is--selected');
      $form.find('[data-current-value]').html('');

      // 工具：按值在某组中找胶囊
      function item($group, val) {
        if (!$group || !$group.length) return $();
        // 兼容字符串/两端空格
        var needle = String(val == null ? '' : val).trim();
        return $group.find(SEL_ITEM).filter(function(){
          return String($(this).attr('data-value')).trim() === needle;
        });
      }

      // 工具：给一组重算状态（可选/售罄/不匹配）
      function refreshGroup($group, key, lock1, lock2) {
        if (!$group || !$group.length) return;
        $group.find(SEL_ITEM).each(function(){
          var $it = $(this);
          var value = $it.attr('data-value');

          // 先清空旧状态
          $it.removeClass(CLS_SOLD_UNAVAIL).removeClass(CLS_UNAVAIL);

          // 找到与其他维度匹配的所有变体
          var matched = variants.filter(function(v){
            if (String(v[key]) !== String(value)) return false;
            if (lock1 && String(v[lock1.k]) !== String(lock1.v)) return false;
            if (lock2 && String(v[lock2.k]) !== String(lock2.v)) return false;
            return true;
          });

          if (!matched.length) {
            // 这个值在当前其它维度组合下根本不存在 → 不匹配
            $it.addClass(CLS_UNAVAIL);
            return;
          }

          // 存在：有一个可售就视为可选，否则售罄（加删除线）
          var anyAvailable = matched.some(function(v){ return !!v.available; });
          if (!anyAvailable) $it.addClass(CLS_SOLD_UNAVAIL);
        });
      }

      // 写当前值 & 保障选中胶囊存在且可见（避免被主题重绘隐藏）
      if (curVar) {
        if ($opt1.length) {
          $opt1.find('[data-current-value]').html(curVar.option1);
          item($opt1, curVar.option1).addClass('is--selected').removeAttr('hidden').css('display','');
        }
        if ($opt2.length) {
          $opt2.find('[data-current-value]').html(curVar.option2);
          item($opt2, curVar.option2).addClass('is--selected').removeAttr('hidden').css('display','');
        }
        if ($opt3.length) {
          $opt3.find('[data-current-value]').html(curVar.option3);
          item($opt3, curVar.option3).addClass('is--selected').removeAttr('hidden').css('display','');
        }
      }

      if (!hasSoldoutUnavailable) return;

      // 重算每组状态（不再依赖数组下标/DOM 顺序）
      if (size >= 1) {
        refreshGroup($opt1, 'option1',
          $opt2.length ? {k:'option2', v:curVar.option2} : null,
          $opt3.length ? {k:'option3', v:curVar.option3} : null
        );
      }
      if (size >= 2) {
        refreshGroup($opt2, 'option2',
          $opt1.length ? {k:'option1', v:curVar.option1} : null,
          $opt3.length ? {k:'option3', v:curVar.option3} : null
        );
      }
      if (size >= 3) {
        refreshGroup($opt3, 'option3',
          $opt1.length ? {k:'option1', v:curVar.option1} : null,
          $opt2.length ? {k:'option2', v:curVar.option2} : null
        );
      }
    }

    // 已经渲染好的商品（本页），也补一手
    try {
      var $roots = $('[data-product-options], [data-product-featured]');
      $roots.each(function(){
        var cmp = $(this).data('t4s-product-instance');
        if (cmp && cmp.Variants) cmp.Variants._updateSwatchSelector = patchedUpdateSwatchSelector;
      });
    } catch(_) {}
  });
})();
